import React, { useState } from "react";
import "../beratungsfeder.css";
import Risikomanagement from "./Risikomanagement";
import Compliance from "./Compliance";
import Internes from "./Internes";
import Governance from "./Governance";

export default function GRCAdvisory() {
	const [cont, setCont] = useState(null);
	const [selList, setSelList] = useState(null);

	const setMenu = (elem, name) => {
		if (selList) {
			selList.classList.remove("active");
		}
		const listItem = elem.target.parentElement;
		listItem.classList.add("active");
		setSelList(listItem);
		setCont(name);
	};

	return (
		<div className="beratungsfeder">
			<div className="side-menu">
				<aside>
					<ul className="side-navigation">
						<li className="category">Governance, Risk, Compliance (GRC)</li>
						<ul className="article_links">
							<li
								className={
									selList ? "article-link-item " : "article-link-item active"
								}
							>
								<button
									aria-label="menu-btn"
									data-to="Risikomanagement"
									className="link_button_sd"
									onClick={(e) => setMenu(e, "Risikomanagement")}
								>
									Risikomanagement
								</button>
							</li>

							<li className="article-link-item ">
								<button
									aria-label="menu-btn"
									data-to="Compliance"
									className="link_button_sd"
									onClick={(e) => setMenu(e, "Compliance")}
								>
									Compliance Management
								</button>
							</li>
							<li className="article-link-item ">
								<button
									aria-label="menu-btn"
									data-to="Internes"
									className="link_button_sd"
									onClick={(e) => setMenu(e, "Internes")}
								>
									Internes Kontrollsystem
								</button>
							</li>
							<li className="article-link-item ">
								<button
									aria-label="menu-btn"
									data-to="Governance"
									className="link_button_sd"
									onClick={(e) => setMenu(e, "Governance")}
								>
									Governance Advisory
								</button>
							</li>
						</ul>
					</ul>
				</aside>
			</div>
			<div className="beratungsfeder-content">
				{cont === "Risikomanagement" || cont === null ? (
					<Risikomanagement />
				) : (
					""
				)}
				{cont === "Compliance" ? <Compliance /> : ""}
				{cont === "Internes" ? <Internes /> : ""}
				{cont === "Governance" ? <Governance /> : ""}
				{}
			</div>
		</div>
	);
}
